export default function handleNextField(e, options, validation, mask = false) {
  const nextSibiling = e && e[0].$el.nextElementSibling;
  const nextInput =
    (nextSibiling && nextSibiling.getElementsByTagName("input")[0]) || false;
  const hasMask =
    options.mask && options.mask.length ? options.mask.length > 0 : false;

  if (nextSibiling !== null && !validation.$invalid && hasMask) {
    if (nextSibiling !== null && !validation.$invalid) {
      if (nextInput) nextInput.focus();
      else return;
    }
  }

  if (mask) {
    if (nextSibiling !== null && !validation.$invalid) {
      if (nextInput) nextInput.focus();
      else return;
    }
  }
}
